import { createRatesService } from './rate.service';

const ENDPOINT = '/api/rdec_scheme_rates';
const RDECSchemeRatesService = createRatesService(ENDPOINT, 'rdec_scheme_rate');

export default RDECSchemeRatesService;